export enum InventoryListType {
    'SITE' = 1,
    'APP' = 2
}
